import React from 'react';
import Select from 'react-select';
import { FaTimes } from 'react-icons/fa';
import FormControl from 'react-bootstrap/FormControl';

import FieldController from '../../controller/FieldController';
import Const from '../../util/Constants';

class FilterText extends React.Component {

  constructor(props) {
    super(props);
    const filter = props.filter;
    this.conditions = FieldController.getConditions(props.field.field_type);
    let condition = filter ? filter.condition : FieldController.In;
    condition = this.conditions.find(item => condition === item.value);
    this.state = { condition: condition, value: filter ? filter.value : '' };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.field.field_key !== this.props.field.field_key) {
      const filter = props.filter;
      let condition = filter ? filter.condition : FieldController.In;
      condition = this.conditions.find(item => condition === item.value);
      this.setState({ ...this.state, condition, value: filter ? filter.value : '' });
    }
  }

  onConditionChanged = select => {
    this.setState({ ...this.state, condition: select, value: '' });
    if(select.value === FieldController.Empty || select.value === FieldController.NotEmpty) {
      this.props.onValueChange(this.props.field.field_key, select.value, '', this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.field_key, this.props.field.model_key);
    }
  }

  handleTextChange = event => {
    this.setState({ ...this.state, value: event.target.value });
    this.props.onValueChange(this.props.field.field_key, this.state.condition.value, event.target.value, 
      this.props.field.model_key);
  }

  render() {
    const condition = this.state.condition ? this.state.condition.value : '';
    const isFilter = (this.state.value && this.state.value.length > 0)
      || !FieldController.showTextFilter(Const.Text, condition);
    return (
      <>
        <div className="row pt-2">
          <div className="col-md-5">
            <p className="headingp">
              {this.props.field.model_key ? <>{this.props.field.model_name}<br/></> : ''}{this.props.field.label_name}
            </p>
          </div>
          <div className={`col-md-${isFilter ? 5: 7}`}>
            <Select value={this.state.condition} onChange={this.onConditionChanged}
              options={this.conditions} isSearchable={true} />
          </div>
          { isFilter ? <div className="col-md-1"><FaTimes 
              onClick={() => this.props.resetFilter(this.props.field.field_key)}/></div> : null }
        </div>

        <div className="row pt-2">
          { FieldController.showTextFilter(Const.Text, condition) ?
            <div className="col-md-12">
              <FormControl type="text" value={this.state.value} onChange={this.handleTextChange}
                className={`mr-sm-2`}
                placeholder="Value" />
            </div> : null
          }
        </div>
        <hr />
      </>
    );
  }
}


export default FilterText;